export enum PremiumFeatures {
    ContactApi = "contactApi",
    LeadsEnrichmentApi = "leadsEnrichmentApi",
    SignalsApi = "signalsApi",
    AdditionalUsers = "additionalUsers",
    DataCredits = "dataCredits",
    ContactCredits = "contactCredits",
    CountryFilters = "countryFilters",
    AppsSdkData = "appsSdkData",
    Integrations = "integrations",
    Enrichment = "enrichment",
    ExtensionIntegration = "extensionIntegration",
    AiOutreach = "aiOutreach",
    AiProspecting = "aiProspecting",
    PrepareMeetings = "prepareMeetings",
}

export enum PremiumFeaturesUserRole {
    Trial = "trial",
    AfterTrial = "afterTrial",
    NoTouch = "noTouch",
    PayingUser = "payingUser",
}
